import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import loginReducer from "../components/Login/loginSlice";
import notificationReducer from "../components/Notification/notificationSlice";
import dialogReducer from "../components/Dialog/dialogSlice";
import backdropLoaderReducer from "../components/BackdropLoader/backdropLoaderSlice";
import subscriptionReducer from "../pages/UpgradeMembership/subscriptionSlice";
import menuReducer from "../components/Menu/menuSlice";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    login: loginReducer,
    notification: notificationReducer,
    dialog: dialogReducer,
    backdropLoader: backdropLoaderReducer,
    selectedPage: menuReducer,
    subscription: subscriptionReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
